export enum TimeSeriesJoinType {
  DATETIME_TO_DATETIME = 'datetime-to-datetime',
  DATETIME_TO_DATE_RANGE = 'datetime-to-dateRange',
  DATETIME_TO_NO_TIME_SERIES = 'datetime-to-noTimeSeries',
  DATE_RANGE_TO_DATETIME = 'dateRange-to-datetime',
  DATE_RANGE_TO_DATE_RANGE = 'dateRange-to-dateRange',
  DATE_RANGE_TO_NO_TIME_SERIES = 'dateRange-to-noTimeSeries',
  NO_TIME_SERIES_TO_NO_TIME_SERIES = 'noTimeSeries-to-noTimeSeries',
}
